export const laBibliotecaSinPuertas = `En un barrio tranquilo se encontraba una biblioteca muy peculiar: no tenía puertas. Cualquiera podía entrar a cualquier hora del día o de la noche. Los libros estaban perfectamente ordenados y nadie los dañaba.

La idea había sido de una profesora jubilada llamada Clara, quien creía que el conocimiento debía estar siempre disponible para todos.

Al principio, muchos vecinos pensaban que robarían los libros, pero ocurrió lo contrario. Las personas cuidaban el lugar con respeto, dejaban notas agradeciendo y regresaban los libros después de leerlos.

Con el tiempo, la biblioteca se volvió un punto de encuentro. Jóvenes, adultos y personas mayores se reunían para leer, compartir ideas y aprender cosas nuevas.

Clara observaba desde una banca cercana y sonreía, sabiendo que había sembrado algo más importante que un edificio: una comunidad.`

export const preguntasBibliotecaSinPuertas = [
	{
		id: "pregunta1",
		pregunta: "¿Qué característica especial tenía la biblioteca?",
		opciones: ["Era muy pequeña", "No tenía ventanas", "No tenía puertas", "Estaba bajo tierra"],
		respuesta: "No tenía puertas",
	},
	{
		id: "pregunta2",
		pregunta: "¿Quién creó la biblioteca?",
		opciones: ["Un arquitecto famoso", "Una profesora jubilada llamada Clara", "El gobierno", "Un grupo de estudiantes"],
		respuesta: "Una profesora jubilada llamada Clara",
	},
	{
		id: "pregunta3",
		pregunta: "¿Qué pensaban los vecinos al principio?",
		opciones: [
			"Que sería un éxito",
			"Que los libros serían robados",
			"Que nadie la usaría",
			"Que sería cerrada pronto"
		],
		respuesta: "Que los libros serían robados",
	},
	{
		id: "pregunta4",
		pregunta: "¿Qué ocurrió realmente con los libros?",
		opciones: [
			"Fueron destruidos",
			"Fueron vendidos",
			"Las personas los cuidaban y regresaban",
			"Nadie los usaba"
		],
		respuesta: "Las personas los cuidaban y regresaban",
	},
	{
		id: "pregunta5",
		pregunta: "¿Qué logró Clara además de crear una biblioteca?",
		opciones: [
			"Ganar dinero",
			"Construir un edificio grande",
			"Crear una comunidad",
			"Volverse famosa"
		],
		respuesta: "Crear una comunidad",
	},
];
